import moment from "moment";
import React from "react";
import Countdown from "react-countdown";
import styled from "styled-components";
import { realtime_type } from "../../../../../helper/const";

export default function LotoTimer({
  codeDetail,
  setEndTimerLotoRealtime,
  endTimerLotoRealtime,
}) {
  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (
      endTimerLotoRealtime &&
      !seconds &&
      endTimerLotoRealtime === realtime_type.real
    ) {
      setEndTimerLotoRealtime(realtime_type.end);
    }
    if (!days && !hours && !minutes) {
      if (seconds) {
        setEndTimerLotoRealtime(realtime_type.real);
      }
      if(!seconds){
        return null
      }
      return (
        <>
          <div className="timer-number-item" style={{ opacity: 0 }}>
            <div className="loto-timer-number">{hours}</div>
            <div>Hours</div>
          </div>
          <div className="timer-number-item">
            <div className="loto-timer-number">{seconds}</div>
            <div>Seconds</div>
          </div>
          <div className="timer-number-item" style={{ opacity: 0 }}>
            <div className="loto-timer-number">{minutes}</div>
            <div>Minutes</div>
          </div>
        </>
      );
    }

    return (
      <>
        <div className="timer-number-item">
          <div className="loto-timer-number">{days}</div>
          <div>Days</div>
        </div>
        <div className="timer-number-item">
          <div className="loto-timer-number">{hours}</div>
          <div>Hours</div>
        </div>
        <div className="timer-number-item">
          <div className="loto-timer-number">{minutes}</div>
          <div>Minutes</div>
        </div>
      </>
    );
  };

  return (
    <Div>
      <Countdown
        date={moment(codeDetail?.codeWinTime, "YYYY-MM-DD HH:mm:ss").format(
          "YYYY-MM-DDTHH:mm:ss"
        )}
        renderer={renderer}
      />
    </Div>
  );
}

const Div = styled.div`
  position: absolute;
  z-index: 6;
  display: grid;
  gap: 2px;
  grid-template-columns: calc(100% / 3) calc(100% / 3) calc(100% / 3);
  width: 192px;
  top: 370px;
  left: 141px;
  justify-content: space-between;

  .timer-number-item {
    text-align: center;
    color: #4d4d4d;
  }

  .loto-timer-number {
    font-weight: bold;
    color: black;
  }

  @media screen and (max-width: 1400px) {
    width: 155px;
    top: 297.5px;
    left: 110px;
    div {
      font-size: 12px;
    }
  }

  @media (max-width: 576px) {
    font-size: 10px;
    top: 226px;
    width: 110px;
    left: 47%;
    transform: translateX(-50%);
  }
`;
